import { html, nothing } from "lit";
import { ActiveFiltersHeader } from "./active-filters-header";
import { when } from "lit/directives/when.js";

export const template = (props: ActiveFiltersHeader) => {
  const isAnyChipActive =
    props.areCustomFiltersActive || props.areCommonFiltersActive || props.areDiagnosticFiltersActive || props.areUpFiltersActive;

  if (!isAnyChipActive && props.searchString.length < 1) return nothing;

  return html`
    <div class="active-filters-header">
      ${when(isAnyChipActive, () => html`<active-filters-badges></active-filters-badges>`)}
      ${when(props.searchString.length > 1, () => html`<activity-history-search-results searchQuery=${props.searchString}></activity-history-search-results>`)}
    </div>
  `;
};
